module.exports = __webpack_public_path__ + "static/media/Detail_Icon_04.e1c112cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_04.png
// module id = 1575
// module chunks = 0